import React, { useEffect, useState } from 'react';
import { api } from '../api.js';
import { errMessage } from '../i18n.js';
import { useT } from '../lang.js';
import Icon from '../Icon.jsx';
import PageSkeleton from '../Skeleton.jsx';

/**
 * Tahsilat hesapları: paranın girdiği kasa/cihaz listesi.
 *
 * NEDEN: "nakit mi kart mı" enum'a gömülüydü; restoranda iki ayrı POS, yemek
 * kartı, havale olabiliyor ve gün sonunda her birinin toplamı ayrı tutuluyor.
 * Liste restoranın kendisi; kurulumda Nakit + Kredi kartı açık gelir.
 *
 * Silme YOK, PASİFE ALMA var: geçmiş ödemeler hesaba bağlı, satırı silmek eski
 * raporu bozardı. Kurulum hesapları hiç kapatılmaz.
 */
// Sunucu AYNI listeyi beyaz liste olarak tutuyor (utils/paymentAccounts.js).
const ICONS = ['cash', 'card', 'wallet', 'phone', 'gift', 'receipt', 'star', 'globe'];
const METHODS = ['CASH', 'CARD', 'WALLET'];

export default function PaymentAccounts() {
  const t = useT();
  const [list, setList] = useState(null);
  const [err, setErr] = useState('');
  const [form, setForm] = useState({ name: '', icon: 'wallet', method: 'CASH' });

  const load = () => api('/api/payments/accounts?all=1').then(setList).catch((e) => setErr(errMessage(t, e)));
  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

  const call = async (path, opts) => {
    setErr('');
    try { await api(path, opts); load(); } catch (e) { setErr(errMessage(t, e)); }
  };

  if (err && !list) return <p className="err">{err}</p>;
  if (!list) return <PageSkeleton shape="table" />;

  return (
    <>
      <div className="card">
        <h2>{t('acc.title')}</h2>
        <table>
          <thead>
            <tr>
              <th style={{ width: 54 }}>{t('acc.icon')}</th>
              <th>{t('acc.name')}</th>
              <th style={{ width: 160 }}>{t('acc.method')}</th>
              <th style={{ width: 120 }}>{t('status')}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {list.map((a) => (
              <tr key={a.id} style={{ opacity: a.active ? 1 : .55 }}>
                <td>
                  <select value={a.icon} onChange={(e) => call(`/api/payments/accounts/${a.id}`, { method: 'PATCH', body: { icon: e.target.value } })}>
                    {ICONS.map((k) => <option key={k} value={k}>{t(`acc.icon.${k}`)}</option>)}
                  </select>
                </td>
                <td>
                  <div className="row" style={{ flexWrap: 'nowrap' }}>
                    <Icon n={a.icon} />
                    <input defaultValue={a.name} style={{ maxWidth: 220 }}
                      onBlur={(e) => e.target.value !== a.name
                        && call(`/api/payments/accounts/${a.id}`, { method: 'PATCH', body: { name: e.target.value } })} />
                  </div>
                </td>
                <td>
                  <select value={a.method} onChange={(e) => call(`/api/payments/accounts/${a.id}`, { method: 'PATCH', body: { method: e.target.value } })}>
                    {METHODS.map((m) => <option key={m} value={m}>{t(`acc.method.${m}`)}</option>)}
                  </select>
                </td>
                <td>
                  {a.system
                    ? <span className="badge">{t('acc.system')}</span>
                    : <span className={`badge ${a.active ? 'ok' : ''}`}>{a.active ? t('acc.active') : t('acc.inactive')}</span>}
                </td>
                <td>
                  {!a.system && (a.active
                    ? <button onClick={() => confirm(t('acc.confirmDisable', { name: a.name }))
                        && call(`/api/payments/accounts/${a.id}`, { method: 'DELETE' })}>
                        <Icon n="power" />{t('acc.disable')}
                      </button>
                    : <button onClick={() => call(`/api/payments/accounts/${a.id}`, { method: 'PATCH', body: { active: true } })}>
                        <Icon n="power" />{t('acc.enable')}
                      </button>)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <p className="muted" style={{ marginBottom: 0 }}>{t('acc.note')}</p>
      </div>

      <div className="card">
        <h2>{t('acc.new')}</h2>
        <div className="row">
          <select style={{ maxWidth: 150 }} value={form.icon} onChange={(e) => setForm({ ...form, icon: e.target.value })}>
            {ICONS.map((k) => <option key={k} value={k}>{t(`acc.icon.${k}`)}</option>)}
          </select>
          <input style={{ maxWidth: 230 }} placeholder={t('acc.namePlaceholder')}
            value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
          <select style={{ maxWidth: 170 }} value={form.method} onChange={(e) => setForm({ ...form, method: e.target.value })}>
            {METHODS.map((m) => <option key={m} value={m}>{t(`acc.method.${m}`)}</option>)}
          </select>
          <button className="primary" onClick={async () => {
            if (!form.name.trim()) return;
            await call('/api/payments/accounts', { method: 'POST', body: form });
            setForm({ name: '', icon: 'wallet', method: 'CASH' });
          }}><Icon n="plus" />{t('add')}</button>
        </div>
      </div>

      {err && <p className="err">{err}</p>}
    </>
  );
}
